// True when a create was refused because a row with that ID already exists (the v2 create
// resolver's condition; errorType DynamoDB:ConditionalCheckFailedException).
export const alreadyExists = (err) =>
  (err?.errors ?? []).some((e) => /ConditionalCheckFailed/.test(e?.errorType ?? ''))
